import React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import ReviewsSummary from '../../../components/ReviewsSummary'
import FlexWrapper from './FlexWrapper'

const ReviewSummaryWidget = ({ data }) => {
  return (
    <FlexWrapper>
      <ReviewsSummary
        average={data.reviewSummaryCatfish.rating.toString()}
        total={data.reviewSummaryCatfish.review_count.toString()}
      />
    </FlexWrapper>
  )
}

const ReviewSummary = () => {
  const data = graphql`
    {
      reviewSummaryCatfish {
        review_count
        rating
      }
    }
  `

  return (
    <StaticQuery
      query={data}
      render={(data) => <ReviewSummaryWidget data={data} />}
    />
  )
}

export default ReviewSummary
